import { render, staticRenderFns } from "./CarDispatch.vue?vue&type=template&id=715b7bf0&scoped=true&"
import script from "./CarDispatch.vue?vue&type=script&lang=js&"
export * from "./CarDispatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715b7bf0",
  null
  
)

export default component.exports